"use client";

import Image from "next/image";

import Button from "@/components/button/Button";
import Arrow from "@/public/svg/arrow-right.svg";
import noCostImg from "@/public/svg/no-cost-img.svg";

import "./price.scss";

const Price = () => {
    return (
        <div className="price-person flex flex-row items-center gap-3 p-6">
            <div className="">
                <div className="price flex items-center gap-3">
                    <span className="chip font-medium px-2">20% Off*</span>
                </div>
                <div className="person flex items-center mt-2  gap-2">
                    <strong>₹40,999 / Person</strong>
                    <span className="line-through">₹52,000 </span>
                </div>
                <h6 className="">Travel Now, Pay Later</h6>
                {/* <Button className="flex-center gap-3 self-start" variant="orange">
                        <span>Talk to us Experts</span>
                        <Image loading="lazy"
                            src={Arrow}
                            alt="Arrow"
                            width={24}
                            height={24}

                        />
                    </Button> */}
            </div>
            <div className="flex-1 flex justify-center">
                <Image
                    loading="lazy"
                    src={noCostImg}
                    alt="no Cost EMI Image"
                    width={80}
                    height={80}
                />
            </div>
        </div>
    );
};

export default Price;
